export const PUBLIC_SEARCH = 'PUBLIC_SEARCH'
export const PUBLIC_SEARCH_SUCCESS = 'PUBLIC_SEARCH_SUCCESS'
export const PUBLIC_SEARCH_FAIL = 'PUBLIC_SEARCH_FAIL'
export const PUBLIC_SEARCH_RESET = 'PUBLIC_SEARCH_RESET'
export const PUBLIC_SEARCH_UPDATE_QUERY = 'PUBLIC_SEARCH_UPDATE_QUERY'
export const PUBLIC_SEARCH_NEXT = 'PUBLIC_SEARCH_NEXT'
export const PUBLIC_SEARCH_NEXT_SUCCESS = 'PUBLIC_SEARCH_NEXT_SUCCESS'
export const PUBLIC_SEARCH_NEXT_FAIL = 'PUBLIC_SEARCH_NEXT_FAIL'
